import { useTranslation } from "react-i18next";
import type { UseLocalizationReturn } from "../localization/types";

/**
 * Custom localization hook that wraps the i18next implementation.
 * This abstraction layer allows for easy replacement of the underlying
 * localization library without changing component code.
 */
export const useLocalization = (): UseLocalizationReturn => {
  const { t, i18n, ready } = useTranslation();

  return {
    t,
    language: i18n.language,
    changeLanguage: async (lang: string) => {
      await i18n.changeLanguage(lang);
    },
    isReady: ready,
  };
};
